<form [formGroup]="formGroup" class="container-company">

  <mat-label class="title-question-wizard margin-top-wizard break">
    {{ 'wizard.nfce.accountantDetails.title' | translate }}
  </mat-label>

  <mat-label class="subtitle-question-wizard margin-top-wizard break">
    {{ 'wizard.nfce.accountantDetails.text-1' | translate }}
  </mat-label>

  <div class="input-container margin-top-wizard">

    <mat-label class="subtitle-question-wizard break">
      {{ 'wizard.nfce.accountantDetails.text-2' | translate }}
    </mat-label>

    <div class="field-container">
      <mat-form-field appearance="outline" class="medium-input-grid phone-adjust-mobile break">
        <mat-label>{{ 'wizard.nfce.accountantDetails.name' | translate }}</mat-label>
        <input matInput formControlName="name">
        <mat-error *ngIf="formGroup.get('name')?.invalid && (formGroup.get('name')?.dirty || formGroup.get('name')?.touched)">
          {{ messageError.errorMessage(formGroup.get('name')!) }}
        </mat-error>
      </mat-form-field>

      <div class="info-bubble">
        {{ 'wizard.nfce.accountantDetails.nameTooltip' | translate }}
      </div>
    </div>

    <div class="field-container">
      <mat-form-field appearance="outline" class="medium-input-grid phone-adjust-mobile break">
        <mat-label>{{ 'wizard.nfce.accountantDetails.email' | translate }}</mat-label>
        <input matInput formControlName="email">
        <mat-error *ngIf="formGroup.get('email')?.invalid && (formGroup.get('email')?.dirty || formGroup.get('email')?.touched)">
          {{ messageError.errorMessage(formGroup.get('email')!) }}
        </mat-error>
      </mat-form-field>

      <div class="info-bubble">
        {{ 'wizard.nfce.accountantDetails.emailTooltip' | translate }}
      </div>
    </div>

    <div class="field-container">
      <mat-form-field appearance="outline" class="medium-input-grid phone-adjust-mobile break">
        <mat-label>{{ 'wizard.nfce.accountantDetails.document' | translate }}</mat-label>
        <input matInput formControlName="document" maxlength="18">
        <mat-error *ngIf="formGroup.get('document')?.invalid && (formGroup.get('document')?.dirty || formGroup.get('document')?.touched)">
          {{ messageError.errorMessage(formGroup.get('document')!) }}
        </mat-error>
      </mat-form-field>

      <div class="info-bubble">
        {{ 'wizard.nfce.accountantDetails.documentTooltip' | translate }}
      </div>
    </div>

    <div class="field-container">
      <mat-form-field appearance="outline" class="medium-input-grid phone-adjust-mobile break">
        <mat-label>{{ 'wizard.nfce.accountantDetails.phone' | translate }}</mat-label>
        <ngx-mat-intl-tel-input
          #phoneInput
          [preferredCountries]="['br']"
          formControlName="phone"
          [enablePlaceholder]="true"
          name="phone"
          [enableSearch]="true"
          (countryChanged)="dialCodeChange($event.dialCode)">
        </ngx-mat-intl-tel-input>

        <mat-error *ngIf="formGroup.get('phone')?.invalid && (formGroup.get('phone')?.dirty || formGroup.get('phone')?.touched)">
          {{ messageError.errorMessage(formGroup.get('phone')!) }}
        </mat-error>
      </mat-form-field>

      <div class="info-bubble">
        {{ 'wizard.nfce.accountantDetails.phoneTooltip' | translate }}
      </div>
    </div>

    <div *ngIf="!isWizard" class="button-container add">
      <button mat-button type="button" class="button-save" (click)="clickSave()">
        {{ 'wizard.nfce.accountantDetails.add' | translate }}
      </button>
    </div>

  </div>
</form>